import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ExportFileService {
    public getReportFileNameWithDate(baseFileName: string | undefined, extension: string): string {
        let date = new Date();
        const day = date.getDate().toString();
        const month = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
        const hours = date.getHours();
        const year = date.getFullYear();
        const seconds = date.getSeconds();
        const minutes = date.getMinutes();
        const fileName = `${day}-${month}-${year} ${hours}.${minutes}.${seconds}`;
        let currentDate = `${day.length == 1 ? "0" + fileName : fileName}`;
        return (baseFileName ?? "") + '_' + currentDate + extension
    }
}
